import { TableCell } from '@mui/material';
import { Status } from '@shared/ui/parts';

export function TransactionStatus({ row }) {
  return <Status data={row?.order_status?.toLowerCase()} />;
}

export default function TransactionStatusCell({ row }) {
  return (
    <TableCell>
      <TransactionStatus row={row} />
    </TableCell>
  );
}
